import headers from './headers'

export default function(fetch) {
  return function({ id, ...data }, dispatch, screenshot) {
    return fetch(`${process.env.REACT_APP_API_URL}/projects/${id}/creator`, {
      headers: headers(),
      method: 'PUT',
      body: JSON.stringify({ screenshot, metadata: { ...data } }),
    })
      .then(res => {
        if (res.status >= 200 && res.status < 299) {
          return res
        }

        return res.json().then(res => {
          throw new Error(res.message)
        })
      })
      .then(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/repositories/putProject.js